import {openMailApp, openShareContents, sendMobileSignIn, sendMoveMobileSignIn, sendMoveMobileSignUp} from "./event.js";


export const sendMoveMobileSignUpPage = () => {
    sendMoveMobileSignUp(getDevice())
}

export const sendMoveMobileSignInPage = () => {
    sendMoveMobileSignIn(getDevice())
}

export const mobileSignIn = (props) => {
    sendMobileSignIn(getDevice(), props);
}
export const mobileOpenMailApp = (props) => {
    openMailApp(getDevice(), props);
}
export const mobileOpenShareContents = (props) => {
    openShareContents(getDevice(), props);
}
const getDevice = () => {
    const uAgent = navigator.userAgent.toLowerCase();
    return (uAgent.indexOf("iphone") >= 0 || uAgent.indexOf("ipad") >= 0) ? "IOS" : "AOS" ;
}

export const SignUpBridge = {
    mobileSignIn
}